import { Component, Input,OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BlockGroupService } from 'app/services/block.group.service';
import { AlertService } from 'app/utils/alert.service';
import { DataPackGroup } from 'app/models/dataPackGroup.model';
import { DataPackLine } from 'app/models/dataPackLine.model';
import { BindComponentService } from '../../../../../utils/bind.component.service';
import { LoadingComponent } from '../../../modalLoading/content.component';

/**
 * @version $Id: content.component.ts 77223 2018-01-23 20:15:02Z edivaldo.m.junior $
 */
@Component({
  selector: 'dataBlockVivoUpModalComponent',
  templateUrl: './content.template.html'
})
export class DataBlockVivoUpModalComponent implements OnInit {

  public static readonly ACTION_RELEASE = 'releaseLines';
  public static readonly ACTION_UNRELEASE = 'unReleaseLines';

  @Input() group: DataPackGroup;
  @Input() lines: Array<DataPackLine>;
  @Input() configSMS: boolean;
  @Input() lineAcountList: any[];
  @Input() dataPackLine: DataPackLine = new DataPackLine();
  public action: string;
  public saving: boolean;

  constructor(private bindComponent: BindComponentService,
    private activeModal: NgbActiveModal,
    private blockGroupService: BlockGroupService,
    private alertService: AlertService,
    private modalService: NgbModal) {
  }

  ngOnInit() {
    if (this.lineAcountList != null && this.lineAcountList.length === 1) {
      this.action = this.dataPackLine.blockedHari ? "ACT" : "DES" ;
    }
  }

  private close() {
    this.activeModal.dismiss();
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  private apply() {
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, true);
    this.saving = true;
    let payload = {
      action: this.action,
      sourceGroup: {
        id: this.group.id
      },
      lines: this.lines
    };
    let promise = this.action === DataBlockVivoUpModalComponent.ACTION_RELEASE ? this.blockGroupService.releaseLines(payload) : this.blockGroupService.unReleaseLines(payload);
    promise.subscribe(
      data => {
        this.saving = false;
        this.alertService.success(data['result']);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.activeModal.close(this.action);        
      },
      err => {
        this.saving = false;
        this.alertService.error(err.result, err);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.activeModal.dismiss();
      }
    );
  }

  public isLiberado(status:String){
    if(status === 'ACT'){
      return true;
    }else if(status === 'DES'){
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/haring/configure/content.component.ts